import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavUserAccessService {

  constructor() {
  }

  getNavigation() {
    // TO DO: Create better user access logic
    return [
      {
        name: "Create New",
        link: "/new-request",
        icon: "plus-circle",
        access: [
          {
            opsLevel: [1, 3]
          }
        ]
      },
      {
        name: "View Adjustment Records",
        link: "/view-adjustment-records",
        icon: "search",
        access: "all"
      }
    ]

  }

  getNavigationAdmin() {
    // TO DO: Create better user access logic
    return [
      {
        name: "View Adjustment Records",
        link: "/view-adjustment-records",
        icon: "search",
        access: "all"
      }
    ]

  }

  getNavigationSuperAdmin() {
    // TO DO: Create better user access logic
    return [
      {
        name: "View Adjustment Records",
        link: "/view-adjustment-records",
        icon: "search",
        access: "all"
      },
      {
        name: "Create New",
        link: "/new-request",
        icon: "plus-circle"
      },
      {
        name: "Update Payroll Admin",
        link: "/admin-edit",
        icon: "plus-circle"
      }
    ]

  }

  //TODO: Create Navigation level permission
  //getCustomNav(level) {
  //if (this.currentUser.opsLevel == level) {

  //}
  //}


}
